import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';

import TicketCategories from './TicketCategories';
import TicketTypes from './TicketTypes';
import { configs } from '../../constants/configs/configs';
import { getHistory } from '../.././reducers/appReducer';

const TicketTypesManager = (props) => {
    const {
        router: {
            location: {
                pathname
            }
        }
    } = props;
    
    return (
        pathname === configs.routes.TICKET_MGMT_TYPES ?
            <div id='ticketTypes'>
                <TicketCategories/>
            </div> :
            <Route path={`${configs.routes.TICKET_MGMT_TYPES}/:ticketCategory/:ticketCategorySpanishName?`} component={TicketTypes}/>
    );
};

const mapStateToProps = state => ({
    router: getHistory(state)
});

export default connect(mapStateToProps)(TicketTypesManager);